export function getValidCategoryIDs () {
    return [1, 15, 9, 18, 17];
}

export function getValidCategoryIDString () {
    return "[15,9,18,17]";
}